// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__Vwhc-","label":"LabeledBox_label__1UFUp"};